import React, { useState } from "react";
import RequestService from "../../services/request.service";


// import '../Reportes/mi_reporte.scss';

// // // import { Modal, Row, Form, Button, Col, InputGroup } from 'react-bootstrap'
// import { Button, Modal, Table, Form } from 'react-bootstrap'

// // import { Formik } from 'formik';
// // import * as yup from 'yup';

import { toast } from 'react-toastify'


import Dialog from '../../services/Dialogs'
// // import { confirm } from '../../widgets/confirm'

// import './mi_reporte.scss';

// import DatePicker, { registerLocale } from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import es from 'date-fns/locale/es';

// import moment from 'moment'

// import Pagination from "../../services/Pagination";



import { useNavigate } from "react-router-dom";
// import EditarTramite from './Modales/editarTramite'
// import EditarTramite from '../Reportes/Modales/editarTramite'


// // import { SERVER_ } from  '../../config';

// import AuthService from "../../features/auth/auth.service";

const VerificacionTelefonica = () =>{



    const dialog = new Dialog()

    let navigate = useNavigate()

  const [ ultimos, setUltimos ] = useState<any>({ por_atender : [], mios : [] })
  const ultimosTramites = async () =>{
    try{
      let res = await RequestService.getEndPoint('verificacion_telefonica/estrategias/ultimos')
      setUltimos(res.data)
    }
    catch(e){
      toast.error('Error al cargar los trámites para Verificación')
    }
  }


  React.useEffect(() => {
    ultimosTramites()
  }, []);


    const atenderTramite = async (uuid_tramite:string)=>{
      try{
        if(await dialog.confirm('¿Estás seguro?',{})){
          await RequestService.create('verificacion_telefonica/tomar_verificacion/'+uuid_tramite,{})
          toast.success('Tu tomaste el control del trámite')
          navigate("../verificacion/"+uuid_tramite, { replace: true })
        }
      }
      catch(e){
        toast.error('Error al tratar de tomar el control del trámite')
        ultimosTramites()
      }
    }


      return (
             
          <>
              <div className="container">
                  
                  <h2>Verificación Telefónica</h2>
                  <hr />


                  {
                    ( ultimos.mios.length === 0 && ultimos.por_atender.length === 0) && (

                        <div className="alert alert-success" role="alert">
                          <h4 className="alert-heading">Espera!</h4>
                          <p>Aún no tienes trámites para atención</p>
                        </div>

                    )
                  }

                  {

                    ( ultimos.mios.length > 0 || ultimos.por_atender.length > 0) && (

                        <table className="table">
                          <thead>
                            <tr>
                              <th scope="col">Folio</th>
                              <th scope="col">Nombre</th>
                              <th scope="col"></th>
                              <th scope="col"></th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              ultimos.mios.map( tramite =>
                                  <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                        <tr>
                                          <td className="v" width={140}>
                                            <h5 className="nm">{ tramite.folio }</h5>
                                          </td>
                                          <td className="v">
                                            <b>{ tramite.nombres } </b>
                                            {
                                               tramite.paterno + ' ' + tramite.materno
                                            }
                                          </td>
                                          <td>
                                            {tramite.curp}
                                          </td>
                                          <td className="v" width={30}>
                                            <i className="fa fa-warning" />
                                          </td>
                                          <td className="v" width={200}>
                                            <button className="btn btn-link" onClick={()=>{ navigate("../verificacion/"+tramite.uuid, { replace: true }) }}>Concluir Atención</button>
                                          </td>
                                        </tr>
                                    
                                  </React.Fragment>

                              )
                            }
                            {
                              ultimos.por_atender.map( tramite =>
                                  <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                        <tr>
                                          <td className="v" width={140}>
                                            <h5 className="nm">{ tramite.folio }</h5>
                                          </td>
                                          <td className="v">
                                            <b>{ tramite.nombres } </b>
                                            {
                                               tramite.paterno + ' ' + tramite.materno
                                            }
                                          </td>
                                          <td>
                                            {tramite.curp}
                                          </td>
                                          <td className="v" width={30}>
                                            
                                          </td>
                                          <td className="v" width={200}>
                                            <button className="btn btn-link"  onClick={()=>{atenderTramite(tramite.uuid)}}>Atender Trámite</button>
                                          </td>
                                        </tr>
                                    
                                  </React.Fragment>

                              )
                            }

                          </tbody>
                        </table>


                    )

                  }






              </div>

          </>

      );
  

}

export default VerificacionTelefonica
